var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-main',[_c('v-sheet',{staticClass:"overflow-hidden",staticStyle:{"position":"relative"},attrs:{"height":"100vh"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }